// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ====================================================
    Responsive
==================================================== */
/* Desktop 1200 - up */
@media (min-width: 1200px) {
    .container {
        max-width: 1200px;
    }
}

/* Normal desktop :992px. (Laptop 14") */
@media (min-width: 992px) and (max-width: 1199px) {
    /* Global */
    h1 {
        font-size: 30px;
    }
    h2 {
        font-size: 26px;
    }
    h3 {
        font-size: 22px;
    }
    h4 {
        font-size: 20px;
    }
    h5 {
        font-size: 18px;
    }
    h6 {
        font-size: 16px;
    }

}

 
/* Tablet device :768px. */
@media (min-width: 768px) and (max-width: 991px) {
    /* Global */
    body {
        font-size: 14px;
    }
    h1 {
        font-size: 26px;
    }
    h2 {
        font-size: 22px;
    }
    h3 {
        font-size: 20px;
    }
    h4 {
        font-size: 18px;
    }
    h5 {
        font-size: 16px;
    }
    h6 {
        font-size: 15px;
    }
    p {
        font-size: 14px;
    }

}

 
/* small mobile :320px. */
@media (max-width: 767px) {
    /* Global */
    body {
        font-size: 14px;
    }
    h1 {
        font-size: 24px;
    }
    h2 {
        font-size: 20px;
    }
    h3 {
        font-size: 18px;
    }
    h4 {
        font-size: 17px;
    }
    h5 {
        font-size: 16px;
    }
    h6 {
        font-size: 14px;
    }
    p {
        font-size: 14px;
    }

}
`, "",{"version":3,"sources":["webpack://./src/assets/css/responsive.css"],"names":[],"mappings":"AAAA;;sDAEsD;AACtD,sBAAsB;AACtB;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA,wCAAwC;AACxC;IACI,WAAW;IACX;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;AAEJ;;;AAGA,0BAA0B;AAC1B;IACI,WAAW;IACX;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;AAEJ;;;AAGA,yBAAyB;AACzB;IACI,WAAW;IACX;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;;AAEJ","sourcesContent":["/* ====================================================\r\n    Responsive\r\n==================================================== */\r\n/* Desktop 1200 - up */\r\n@media (min-width: 1200px) {\r\n    .container {\r\n        max-width: 1200px;\r\n    }\r\n}\r\n\r\n/* Normal desktop :992px. (Laptop 14\") */\r\n@media (min-width: 992px) and (max-width: 1199px) {\r\n    /* Global */\r\n    h1 {\r\n        font-size: 30px;\r\n    }\r\n    h2 {\r\n        font-size: 26px;\r\n    }\r\n    h3 {\r\n        font-size: 22px;\r\n    }\r\n    h4 {\r\n        font-size: 20px;\r\n    }\r\n    h5 {\r\n        font-size: 18px;\r\n    }\r\n    h6 {\r\n        font-size: 16px;\r\n    }\r\n\r\n}\r\n\r\n \r\n/* Tablet device :768px. */\r\n@media (min-width: 768px) and (max-width: 991px) {\r\n    /* Global */\r\n    body {\r\n        font-size: 14px;\r\n    }\r\n    h1 {\r\n        font-size: 26px;\r\n    }\r\n    h2 {\r\n        font-size: 22px;\r\n    }\r\n    h3 {\r\n        font-size: 20px;\r\n    }\r\n    h4 {\r\n        font-size: 18px;\r\n    }\r\n    h5 {\r\n        font-size: 16px;\r\n    }\r\n    h6 {\r\n        font-size: 15px;\r\n    }\r\n    p {\r\n        font-size: 14px;\r\n    }\r\n\r\n}\r\n\r\n \r\n/* small mobile :320px. */\r\n@media (max-width: 767px) {\r\n    /* Global */\r\n    body {\r\n        font-size: 14px;\r\n    }\r\n    h1 {\r\n        font-size: 24px;\r\n    }\r\n    h2 {\r\n        font-size: 20px;\r\n    }\r\n    h3 {\r\n        font-size: 18px;\r\n    }\r\n    h4 {\r\n        font-size: 17px;\r\n    }\r\n    h5 {\r\n        font-size: 16px;\r\n    }\r\n    h6 {\r\n        font-size: 14px;\r\n    }\r\n    p {\r\n        font-size: 14px;\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
